import { HeaderProps, PageWrapper } from '@components/page-wrapper';
import { Card, Divider, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import { NextPage } from 'next';
import React from 'react';
import { useIntl } from 'react-intl';
import { TENANT, Tenant } from '../../tenant/tenant';
import { TENANT_IMPRINT } from '../../tenant/tenant-imprint';

const LegalNotice: NextPage = () => {
  const { formatMessage } = useIntl();

  const sections = [
    {
      key: 'address',
      content: (
        <div>
          <p>{TENANT_IMPRINT.companyName}</p>
          <p style={{ marginBottom: 0 }}>
            {TENANT_IMPRINT.addressLines.map((line, i) => (
              <span key={i}>
                {line}
                {i < TENANT_IMPRINT.addressLines.length - 1 && <br />}
              </span>
            ))}
          </p>
        </div>
      ),
    },
    {
      key: 'representatives',
      content: (
        <div>
          <div>{formatMessage({ id: 'imprint.represented-by' })}</div>
          <div style={{ marginTop: 10 }}>
            {TENANT_IMPRINT.representatives.map((representative) => (
              <div key={representative}>{representative}</div>
            ))}
          </div>
        </div>
      ),
    },
    TENANT_IMPRINT.contactFormUrl
      ? {
          key: 'contact',
          content: (
            <div>
              <div>{formatMessage({ id: 'imprint.contact' })}</div>
              <div style={{ marginTop: 10 }}>
                {formatMessage({ id: 'imprint.contact-form' })}{' '}
                <a href={TENANT_IMPRINT.contactFormUrl} target="_blank" rel="noreferrer">
                  {formatMessage({ id: 'imprint.contact-form.click' })}
                </a>
              </div>
              {TENANT_IMPRINT.generalEmail && (
                <div>
                  {formatMessage({ id: 'imprint.general' })}{' '}
                  <a
                    href={`mailto:${TENANT_IMPRINT.generalEmail}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {TENANT_IMPRINT.generalEmail}
                  </a>
                </div>
              )}
              {TENANT_IMPRINT.jobsEmail && (
                <div>
                  {formatMessage({ id: 'imprint.jobs' })}{' '}
                  <a href={`mailto:${TENANT_IMPRINT.jobsEmail}`} target="_blank" rel="noreferrer">
                    {TENANT_IMPRINT.jobsEmail}
                  </a>
                </div>
              )}
            </div>
          ),
        }
      : null,
    {
      key: 'register',
      content: (
        <div>
          <div>{formatMessage({ id: 'imprint.registration-commercial-register' })}</div>
          <div style={{ marginTop: 10 }}>
            {TENANT_IMPRINT.registerLines.map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </div>
          {TENANT_IMPRINT.taxId && (
            <div style={{ marginTop: 10 }}>Tax-ID: {TENANT_IMPRINT.taxId}</div>
          )}
        </div>
      ),
    },
    TENANT_IMPRINT.phone || TENANT_IMPRINT.fax
      ? {
          key: 'phone-fax',
          content: (
            <div>
              {TENANT_IMPRINT.phone && (
                <div>
                  {formatMessage({ id: 'imprint.phone' })} {TENANT_IMPRINT.phone}
                </div>
              )}
              {TENANT_IMPRINT.fax && (
                <div>
                  {formatMessage({ id: 'imprint.fax' })} {TENANT_IMPRINT.fax}
                </div>
              )}
            </div>
          ),
        }
      : null,
    TENANT_IMPRINT.dataProtectionOfficerEmail
      ? {
          key: 'data-protection-officer',
          content: (
            <div>
              <div>{formatMessage({ id: 'imprint.data-protection-officer' })}</div>
              <div style={{ marginTop: 10 }}>
                <a
                  href={`mailto:${TENANT_IMPRINT.dataProtectionOfficerEmail}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {TENANT_IMPRINT.dataProtectionOfficerEmail}
                </a>
              </div>
            </div>
          ),
        }
      : null,
    TENANT_IMPRINT.dataProtectionAuthority
      ? {
          key: 'data-protection-authority',
          content: (
            <div>
              <div>{formatMessage({ id: 'imprint.data-protection-authority' })}</div>
              <div style={{ marginTop: 10 }}>
                {TENANT_IMPRINT.dataProtectionAuthority.map((line, i) => (
                  <div key={i}>{line}</div>
                ))}
              </div>
            </div>
          ),
        }
      : null,
    TENANT === Tenant.avelios
      ? {
          key: 'responsibility',
          content: (
            <div>
              <div>{formatMessage({ id: 'imprint.responsibility' })}</div>
              <div>{formatMessage({ id: 'imprint.note' })}</div>
            </div>
          ),
        }
      : null,
  ].filter(Boolean) as { key: string; content: React.ReactNode }[];

  return (
    <PageWrapper headerProps={headerProps}>
      <Card>
        <Title>{formatMessage({ id: 'imprint' })}</Title>
        <Space style={{ width: '100%' }} size={8} direction="vertical">
          {sections.flatMap((section, i) => [
            i > 0 ? <Divider key={`divider-${i}`} style={{ margin: 0 }} /> : null,
            <div key={section.key}>{section.content}</div>,
          ])}
        </Space>
      </Card>
    </PageWrapper>
  );
};

const headerProps: HeaderProps = {
  title: 'Impressum',
};

export default LegalNotice;
